import { Link } from "react-router-dom";
import { HeroProofRotator } from "@/components/directory/HeroProofRotator";
import { BRAND_ASSETS } from "@/utils/brandAssets";

const QUICK_CATEGORIES = [
  ["Yoga and Pilates", "/?category=fitness"],
  ["Massage and recovery", "/?category=recovery"],
  ["Healthy food", "/?category=nutrition"],
  ["Gyms and training", "/?category=fitness"],
  ["Coaches and providers", "/?category=services"],
  ["Browse the map", "/map"],
  ["Coverage areas", "/areas"],
];

export function DirectoryHero({ proofPoints, symptomQuery, onSymptomQueryChange, matchedDomains, onSearch, onClear }) {
  return (
    <section className="relative isolate min-h-[560px] overflow-hidden bg-navy-dark text-white lg:min-h-[610px]" data-testid="directory-hero">
      <img src={BRAND_ASSETS.homeHero} alt="Wellness Collective AI members pursuing connected health goals" className="absolute inset-0 -z-20 h-full w-full object-cover object-center" data-testid="directory-hero-image" />
      <div className="absolute inset-0 -z-10 bg-navy-dark/70" aria-hidden="true" />
      <div className="iw-grid-bg-dark absolute inset-0 -z-10 opacity-35" aria-hidden="true" />
      <div className="relative mx-auto flex min-h-[560px] max-w-7xl items-center px-4 py-12 sm:px-6 lg:min-h-[610px] lg:px-8">
        <div className="max-w-3xl">
          <p className="hero-brand-kicker font-mono text-xs uppercase text-white/65 mb-5" data-testid="hero-coverage-pill">Integrated wellness discovery · Nationwide</p>
          <h1 className="hero-brand-title font-heading text-4xl sm:text-5xl lg:text-6xl text-white font-bold leading-[1.04] mb-6" data-testid="hero-brand-title">
            <span className="block">Find wellness that fits</span>
            <span className="block text-[#F45B63]">your whole health.</span>
          </h1>
          <p className="hero-brand-description font-body text-lg text-white/85 leading-relaxed max-w-4xl mb-5" data-testid="hero-brand-description">
            Search real venues and providers, compare evidence and community signals, and connect every wellness goal to practical next steps.
          </p>
          <HeroProofRotator proofPoints={proofPoints} />

          <div className="max-w-3xl" data-testid="symptom-search">
            <label htmlFor="directory-goal-search" className="block font-mono text-xs font-semibold uppercase text-white mb-2">What are you looking for?</label>
            <div className="clinical-frame flex flex-col overflow-hidden border-2 border-white bg-white sm:flex-row">
              <input
                id="directory-goal-search"
                type="text"
                value={symptomQuery}
                onChange={(event) => onSymptomQueryChange(event.target.value)}
                onKeyDown={(event) => event.key === "Enter" && onSearch()}
                placeholder="Try counseling, massage, yoga, or nutrition"
                className="flex-1 min-h-[56px] bg-white text-navy placeholder-gray-400 outline-none font-body text-base px-5"
                data-testid="symptom-search-input"
              />
              <button onClick={onSearch} className="bg-brand-red hover:bg-red-800 text-white px-7 min-h-[56px] font-mono text-xs uppercase font-bold transition-colors" data-testid="symptom-search-btn">
                Find wellness →
              </button>
            </div>
            {matchedDomains.length > 0 && (
              <div className="mt-3 flex flex-wrap gap-2 items-center" data-testid="hero-matched-filters">
                <span className="text-white/60 text-xs font-body">Matched health focus:</span>
                {matchedDomains.map((domain) => <span key={domain} className="bg-white text-navy text-xs px-2.5 py-1 font-body font-semibold">{domain}</span>)}
                <button onClick={onClear} className="text-white text-xs font-body underline underline-offset-4" data-testid="symptom-clear-btn">Clear</button>
              </div>
            )}
          </div>

          <div className="flex gap-2 flex-wrap mt-5" data-testid="hero-quick-categories">
            {QUICK_CATEGORIES.map(([label, href]) => (
              <Link key={label} to={href} className="border border-white/25 bg-navy-dark/55 px-3 py-2 text-white/85 hover:border-white hover:text-white font-mono text-[10px] uppercase transition-colors" data-testid={`hero-quick-cat-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{label}</Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}